import React from 'react';
import { useClearAllFilters } from 'app/hooks/useClearAllFilters';
import styles from './ClearAllButton.module.scss';

interface ClearAllButtonProps {
  onClear?: () => void;
}

export function ClearAllButton({ onClear }: ClearAllButtonProps) {
  const clearAllFilters = useClearAllFilters();

  const handleClearAll = () => {
    clearAllFilters();
    onClear?.();
  };

  return (
    <button
      onClick={handleClearAll}
      className={styles.clearAllButton}
      aria-label="Clear all filters"
      type="button"
    >
      Clear All
    </button>
  );
}
